
import { EntityRelationAgentAccounts } from "@/core/directive/interface/entityRelationships";
import { defineComponent } from "vue";

export default defineComponent({
  name: "common-agent-account-option",
  props: {
    option: {
      type: Object as () => EntityRelationAgentAccounts,
    },
    discountValue: {
      type: Number,
      default: 0,
    },
  },
  setup() {
    return {};
  },
});
